import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';

export interface HomepageSettings {
  id: string | null;
  image_url: string | null;
  main_text: string;
  hero_click_name: string | null;
  hero_click_url: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export const useHomepageSettings = () => {
  return useQuery<HomepageSettings | null>({
    queryKey: ['homepage-settings'],
    queryFn: async () => {
      try {
        const response = await apiService.getHomepageSettings();
        return response as HomepageSettings;
      } catch (error) {
        // Return null to trigger fallback to default values
        return null;
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2, // Retry failed requests twice
  });
};